import type { Slicer } from '@swf/core/store';

import type { HelpCenterCategoryWidgetState } from './types';

export const selectors = (slice: Slicer<HelpCenterCategoryWidgetState>) => ({
  categoriesList: () =>
    slice((state) => state.categoriesList.filter((category) => category.title !== null)),
  categoryArticles: () => slice((state) => state.categoryArticles),
  categoryArticlesMeta: () => slice((state) => state.categoryArticlesMeta),
  pageSize: () => slice((state) => state.pageSize),
  isLoading: () => slice((state) => state.isLoading),
  hasPreloaded: () => slice((state) => state.preloaded)
});
